import { subscribeOn } from 'rxjs/operators';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../constants/sm-constants';

@Component({
  selector: 'sm-add-other-expenses',
  templateUrl: './add-other-expenses.component.html',
  styleUrls: ['./add-other-expenses.component.scss']
})
export class AddOtherExpensesComponent implements OnInit, OnDestroy {

  otherExpenseData: any = {}
  maxDate: Date = new Date()
  private apisub: Subscription
  constructor(  @Inject(MAT_DIALOG_DATA) public parentData: any, private loaderservice: LoaderServiceService, private _apiservice: ApiService) {
    this.apisub = this._apiservice.apiResult.subscribe(res => {
      if(res){
        if(res.responseType = SM_CONSTANTS.RESULT_API_UPDATE_EXPENSE_INFO){
          if(res.result && res.result != null){
            this.parentData.ref.closeAll();
          }
        }
      }
    })

   }

  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

  onPost(){
    let bodydata = {
      "expenseInfo": {
        "label": this.otherExpenseData.label, 
        "amount": this.otherExpenseData.amount, 
        "expenseType": 1, 
        "expenseDateTime": this.formatDate1(this.otherExpenseData.expenseDateTime), 
        "reason": this.otherExpenseData.reason,
    }
    }

    this.loaderservice.showLoader = true
    this._apiservice.updateExpenseInfo(bodydata)
  }

  formatDate(dateStr:string) {
    
    // Split the date string by `/`
    const parts = dateStr.split('/');
  
    // Reverse the order of the parts and join them with `-`
    const newDateStr = parts.reverse().join('-');
  
    // Return the formatted date string
    return newDateStr;
  }
  formatDate1(dateStr:Date) {

    let curdate = new Date(dateStr).toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);
      console.log(curdate);
      
      return curdate
  }


}
